import styles from '../../../../../common/preview-block/Preview.module.scss';
import React from 'react';

const Preview = () => {
  return (
    <div
      id='libraryBusinessFolderPreview'
      role='dialog'
      onKeyDown={(e) => e.stopPropagation()}
      className={styles.template_preview_container}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <p id='libraryBusinessFolderPreviewText'>
        The Business Folder includes essential documents to run a business legally and efficiently.
        It covers advisory boards, confidentiality, founder and profit agreements, financial setup,
        and client contracts. Used properly, it protects against disputes, lost revenue, data
        breaches, and regulator fines. This folder helps avoid over 80% of common legal issues in
        small businesses.
      </p>
    </div>
  );
};

export default Preview;
